import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import EntityTimestamp from '../../entities/entityTimestamp';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
export function canDeleteEntityTimestamp(): boolean {
return true;
}
export function collectEntityTimestampDeleteImpact(entityTimestamp: EntityTimestamp, context: DeleteImpactContext): void {
const key = 'entityTimestamp:' + entityTimestamp.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
}
export function deleteImpactEntityTimestamp(entityTimestamp: EntityTimestamp): DeleteImpact {
const context = deleteImpactContext();
collectEntityTimestampDeleteImpact(entityTimestamp, context);
return deleteImpactCounts(context);
}
export function deleteEntityTimestamp(entityTimestamp: EntityTimestamp, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteEntityTimestamp()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectEntityTimestampDeleteImpact(entityTimestamp, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || entityTimestamp.id};
}
const key = 'entityTimestamp:' + entityTimestamp.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));

const deleted = entityTimestamp.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.EntityTimestampActions.removeEntityTimestampQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}
